import React from "react";
import BottomNavigation, {
  BottomNavigationAction
} from "material-ui/BottomNavigation";
import { Button, Paper } from "material-ui";
import { withStyles } from "material-ui/styles";
import { isAdmin } from "utils/formatter";
import ErrorMessage from "components/ErrorMessage";
import CInput from "uis/CInput";
import CTooltips from "uis/CTooltips";
import storage from "utils/storage";
import Container from "./Container";

const styles = theme => ({
  container: {
    padding: 20,
    margin: "20px auto",
    width: 1100,
    position: "relative"
  },
  header: {
    display: "flex"
  },
  title: {
    margin: 0,
    flex: 1,
    color: "#575962"
  },
  main: {
    padding: 20,
    marginBottom: 10
  },
  subTitle: {
    color: "#575962",
    display: "inline-block",
    width: 150,
    marginRight: 50,
    marginBottom: 0,
    fontSize: "1.4rem"
  },
  buttons: {
    position: "absolute",
    right: 40,
    left: 40,
    bottom: 20
  },
  clear: {
    clear: "both"
  },
  cancelBtn: {
    marginRight: 10
  },
  actionBtn: {
    marginRight: 10,
    width: 225
  },
  errorMessage: {
    fontSize: ".9rem",
    marginBottom: 10
  },
  paperDesc: {
    color: "#9699a2",
    fontSize: "1.1rem",
    display: "flex",
    alignItems: "flex-end"
  },
  attrListLabel: {
    flex: 1
  },
  attrListCaution: {
    color: "black",
    float: "right",
    fontSize: "0.9rem"
  },
  tooltipS: {
    width: 220
  },
  tooltipM: {
    width: 450
  },
  button: {
    cursor: "pointer",
    border: 0,
    display: "inline-flex",
    outline: "none",
    position: "relative",
    userSelect: "none",
    alignItems: "center",
    verticalAlign: "middle",
    textDecoration: "none",
    justifyContent: "center",
    WebkitAppearance: "none",
    WebkitTapHighlightColor: "transparent",

    padding: "8px 16px",
    minWidth: 88,
    fontSize: "1rem",
    boxSizing: "border-box",
    minHeight: 36,
    transition:
      "background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    lineHeight: "1.4em",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 500,
    borderRadius: 2,
    textTransform: "uppercase",

    color: "#f4f5f8",
    boxShadow:
      "0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12)",
    backgroundColor: "#4A3E92",

    "&:hover": {
      backgroundColor: "rgba(74, 62, 146, 0.7)",
      textDecoration: "none"
    },
    "$:active": {
      boxShadow:
        "0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12)"
    }
  },
  textAlignRight: {
    textAlign: "right",
    marginBottom: ""
  },
  launchAttrBtn: {
    background: "none",
    border: "none",
    cursor: "pointer",
    outline: "none",
    fontSize: "1rem",
    color: theme.palette.link
  },
  validItem: {
    marginTop: 1,
    color: "red",
    textAlign: "center",
  }
});

class SelectAttr extends React.Component {
  componentWillMount() {
    if (storage.isReloaded()) {
      storage.removeReloaded();
      if (this.isNew()) {
        this.props.history.go(-1);
      }
    }
    if (!this.isNew()) {
      this.props.fetchSurveyDetail();
    }
    this.totalItemsCount();
    window.scroll(0, 0);
    window.addEventListener("beforeunload", this.showReloadAlert);
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.showReloadAlert);
  }

  showReloadAlert(e) {
    storage.setReloaded();
    e.returnValue = "行った変更が保存されない可能性があります。";
  }

  naviStyle(localeNo) {
    return this.props.selectAttr.localeNo === localeNo
      ? { color: "#fff", backgroundColor: "#26a69a" }
      : { color: "#333", backgroundColor: "transparent" };
  }
  totalItemsCount() {
    const data = this.props.selectAttr.items;
    const totalItemCounts = Object.values(data).reduce((list, item) => {
      if (item.isSelect) {
        return list + item.itemCount;
      }
      return list;
    }, 0);
    return totalItemCounts;
  }
  isNew() {
    const { pathname } = window.location;
    return pathname.indexOf("/create_survey/") > -1;
  }

  render() {
    const {
      classes,
      customer,
      survey,
      selectAttr,
      changeUseAttrs,
      baseInfo,
      attrUpdatedAt,
      errors
    } = this.props;

    return (
      <Paper className={classes.container}>
        <div className={classes.header}>
          <h2 className={classes.title}>
            アンケート{this.isNew() ? "登録" : "更新"}
          </h2>
        </div>

        <div className={classes.main}>
          <ErrorMessage messages={errors} className={classes.errorMessage} />
          <div>
            <h3 className={classes.subTitle}>属性選択</h3>
            <CTooltips
              title="属性設定画面で設定した内容を、この画面に再読込みします。"
              placement="bottom-end"
              light="true"
              classes={{ tooltip: classes.tooltipM, button: classes.button }}
              style={{ float: "right" }}
              button="true"
              onClick={() =>
                this.props.handleReload(customer, survey, selectAttr)
              }
            >
              <div style={{ marginRight: 5, height: 20 }}>再読込み</div>
            </CTooltips>

            <div className={classes.textAlignRight}>
              <button
                className={classes.launchAttrBtn}
                onClick={() => {
                  return isAdmin()
                    ? window.open(`/admin/setup_attr/${customer.id}`)
                    : window.open(`/customer_admin/setup_attr/${customer.id}`);
                }}
              >
                属性設定画面を開く
              </button>
            </div>
          </div>

          <Paper style={{ marginBottom: 20, height: 520 }}>
            {/* 言語タブ */}
            <div>
              <BottomNavigation
                style={{ justifyContent: "left" }}
                value={selectAttr.localeNo}
                onChange={this.props.changeLocale}
                showLabels
              >
                {baseInfo.useLocales.indexOf("ja") > -1 && (
                  <BottomNavigationAction
                    style={this.naviStyle("ja")}
                    value="ja"
                    label="日本語"
                  />
                )}
                {baseInfo.useLocales.indexOf("en") > -1 && (
                  <BottomNavigationAction
                    style={this.naviStyle("en")}
                    value="en"
                    label="英語"
                  />
                )}
                {baseInfo.useLocales.indexOf("zh") > -1 && (
                  <BottomNavigationAction
                    style={this.naviStyle("zh")}
                    value="zh"
                    label="中国語"
                  />
                )}
                {baseInfo.useLocales.indexOf("vi") > -1 && (
                  <BottomNavigationAction
                    style={this.naviStyle("vi")}
                    value="vi"
                    label="ベトナム語"
                  />
                )}
              </BottomNavigation>
            </div>

            <div style={{ height: 408 }}>
              <div style={{ padding: 7 }}>
                <div className={classes.paperDesc}>
                  <div className={classes.attrListLabel}>
                    属性回答方法の説明
                  </div>
                  <div className={classes.attrListCaution}>
                    属性の回答について補足する文言が必要であれば記入してください。
                  </div>
                  <div className={classes.clear} />
                </div>

                <div
                  className={classes.paperPeriod}
                  style={{ marginBottom: 20 }}
                >
                  <CInput
                    multiline
                    fullWidth
                    rows="3"
                    value={selectAttr.answerMethods[selectAttr.localeNo]}
                    onChange={e =>
                      this.props.changeItem("answerMethods", e.target.value)
                    }
                    inputProps={{
                      maxLength: 1000
                    }}
                  />
                </div>

                <div className={classes.paperDesc} style={{ marginBottom: 6 }}>
                  <div className={classes.attrListLabel}>属性一覧</div>
                  <div className={classes.attrListCaution}>
                    属性の内容および並び順の変更は、属性設定画面で行ってください。
                  </div>
                  <div className={classes.clear} />
                </div>

                <div
                  style={{
                    padding: 10,
                    border: "1px solid darkgrey",
                    overflowY: "scroll",
                    height: 250
                  }}
                >
                  <Container {...selectAttr} changeUseAttrs={changeUseAttrs} />
                </div>
                <div className={classes.validItem} hidden={!(this.totalItemsCount() > 45)} >
                  属性選択肢の上限は条件によって異なりますのでご注意下さい。<br />
                  システムのみを使用する場合：合計45 マークシートを併用する場合：合計36 （F1:12個、F2:6個、F3:6個、F4:6個、F5:6個）
                </div>
              </div>
            </div>
          </Paper>
        </div>
        <div className={classes.buttons}>
          {this.isNew() && (
            <div style={{ position: "absolute" }}>
              <Button
                style={{ froat: "left" }}
                raised
                className={classes.cancelBtn}
                onClick={() => {
                  this.props.history.go(-2);
                }}
              >
                キャンセル
              </Button>
            </div>
          )}
          <div style={{ textAlign: "center" }}>
            {this.isNew() ? (
              <div>
                <Button
                  raised
                  className={classes.actionBtn}
                  onClick={() => {
                    this.props.handlePrev({
                      attrUpdatedAt,
                      customerId: customer.id
                    });
                  }}
                >
                  前（基本情報）へ
                </Button>
                <Button
                  raised
                  disabled={this.totalItemsCount() > 45}
                  className={classes.actionBtn}
                  onClick={() => {
                    this.props.handleNext({
                      baseInfo: this.props.baseInfo,
                      selectAttr: this.props.selectAttr,
                      attrUpdatedAt,
                      customerId: customer.id
                    });
                  }}
                >
                  次（基本設問文言設定）へ
                </Button>
              </div>
            ) : (
              <div>
                <Button
                  style={{ froat: "left" }}
                  raised
                  className={classes.cancelBtn}
                  onClick={() => {
                    this.props.history.goBack();
                  }}
                >
                  キャンセル
                </Button>
                <Button
                  raised
                  disabled={this.totalItemsCount() > 45}
                  onClick={() => {
                    this.props.handleUpdate({
                      survey: this.props.survey,
                      baseInfo: this.props.baseInfo,
                      selectAttr: this.props.selectAttr,
                      attrUpdatedAt,
                      customerId: customer.id
                    });
                  }}
                >
                  更新
                </Button>
              </div>
            )}
          </div>
        </div>
      </Paper>
    );
  }
}

export default withStyles(styles)(SelectAttr);



// WEBPACK FOOTER //
// ./src/components/CreateSurvey/SelectAttr/index.jsx